import { z } from "zod/v4";

export const AgencyCustomerDtoSchema = z.object({
  id: z.uuid(),
  stripeCustomerId: z.string(),
  agencyId: z.uuid(),
  name: z.string().nullish(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  billing: z.boolean().nullish(),
});

export type AgencyCustomerDto = z.infer<typeof AgencyCustomerDtoSchema>;

export const CreateAgencyCustomerDtoSchema = AgencyCustomerDtoSchema.extend({
  id: z.uuid().nullish(),
}).omit({
  name: true,
  email: true,
  phone: true,
});

export type CreateCustomerGroupDto = z.infer<
  typeof CreateAgencyCustomerDtoSchema
>;
